import EleImport from './EleImport'

if (window && window.Vue) {
  window.Vue.component(EleImport.name, EleImport)
}

export default EleImport
